import { Tooltip as AlchemyTooltip } from '@m/alchemy-ui/Tooltip';
import { FlagIcon } from '@m/alchemy-ui/icons/FlagIcon';
import { useIntl } from 'react-intl';
import * as Styled from './IdeaCard.styled';

export const FlaggedIndicator = () => {
  const intl = useIntl();

  return (
    <AlchemyTooltip
      trigger={
        <Styled.FlaggedBadge>
          <FlagIcon size={14} aria-hidden="true" />
        </Styled.FlaggedBadge>
      }
      placement="left"
      contents={intl.formatMessage({
        id: 'pendingModeratorAttention',
        defaultMessage: 'Pending moderator attention'
      })}
    />
  );
};
